import cx from "classnames"

import styles from "./index.module.css"

const PLACEMENTS = {
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right",
}

const SIZE = {
  S: "small",
  M: "medium",
  L: "large",
}

export const Tooltip = ({ text = "", placement = PLACEMENTS.BOTTOM, size = SIZE.M, children }) => {
  const tooltipClass = cx(styles.tooltip, {
    [styles.sizeS]: size === SIZE.S,
    [styles.sizeM]: size === SIZE.M,
    [styles.sizeL]: size === SIZE.L,
  })

  return (
    <div className={tooltipClass} data-tooltip={text} data-tooltip-location={placement}>
      {children}
    </div>
  )
}

export { PLACEMENTS as tooltipPlacements, SIZE as tooltipSizes }
